import { render, staticRenderFns } from "./PDPAnalysis.vue?vue&type=template&id=704989da&scoped=true"
import script from "./PDPAnalysis.vue?vue&type=script&lang=js"
export * from "./PDPAnalysis.vue?vue&type=script&lang=js"
import style0 from "./PDPAnalysis.vue?vue&type=style&index=0&id=704989da&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704989da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('704989da')) {
      api.createRecord('704989da', component.options)
    } else {
      api.reload('704989da', component.options)
    }
    module.hot.accept("./PDPAnalysis.vue?vue&type=template&id=704989da&scoped=true", function () {
      api.rerender('704989da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/dashboard/PDPAnalysis.vue"
export default component.exports